export default "__VITE_ASSET__CqrbQhID__"